import styled from 'styled-components';

export const SearchOption = styled.span`
  color: ${props => props.theme.colors.link};
  font-size: 14px;
  line-height: 14px;
`;

export const AvatarPlaceHolder = styled.img`
  border-radius: 50%;
  background-color: ${props => props.color || '#d9d9d9'};;
  margin-right: 5px;
  width: 20px;
  height: 20px;
`;

export const Avatar = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 5px;;
  border-radius: 50%;
`;

export const ItemIcon = styled.span`
  color: ${props => props.color || '#d9d9d9'};
  cursor: pointer;
`;

export const Label = styled.span`
`;
